var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wait-content"},[_c('div',{staticClass:"bg-img"},[_c('img',{attrs:{"src":_vm.image,"alt":"等待考试"}})]),_vm._m(0),_c('div',{staticClass:"mask"})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-txt"},[_c('p',[_vm._v("您来早啦！考试还未开始哦~")])])
}]

export { render, staticRenderFns }